import { useState } from 'react';
import {
  isLocalhost,
  detectEnvFromHostname,
  resolveEnvForToken,
  redirectToPollyLogin,
  loadSelectedEnv,
  saveSelectedEnv,
} from '../../utils/auth';
import { PollyEnv } from '../../types';

interface UseAuthReturn {
  /** Only true on localhost — lets AuthForm show the env toggle. */
  showEnvToggle: boolean;
  selectedEnv: PollyEnv;
  setSelectedEnv: (env: PollyEnv) => void;
  redirecting: boolean;
  triggerRedirect: () => void;
}

export function useAuth(_onAuthenticated: () => void): UseAuthReturn {
  const [redirecting, setRedirecting] = useState(false);

  // On deployed envs the env is fixed by hostname — no toggle needed.
  // On localhost the user can pick testpolly or polly.
  const showEnvToggle = isLocalhost();

  const [selectedEnv, setSelectedEnvState] = useState<PollyEnv>(() =>
    isLocalhost() ? loadSelectedEnv() : detectEnvFromHostname()
  );

  const setSelectedEnv = (env: PollyEnv) => {
    saveSelectedEnv(env);
    setSelectedEnvState(env);
  };

  const triggerRedirect = () => {
    setRedirecting(true);
    // On deployed envs always use hostname-derived env (ignores any stored pref).
    // On localhost use the user's toggle selection.
    const env = isLocalhost() ? selectedEnv : resolveEnvForToken();
    redirectToPollyLogin(env);
  };

  return { showEnvToggle, selectedEnv, setSelectedEnv, redirecting, triggerRedirect };
}
